export default __webpack_public_path__ + "static/media/companyibc.3a1fa2c9.png";